import CarEngineRepairMoney from '@/icons/car-engine-repair-money';
import EnterDoor from '@/icons/enter-door';
import MoneyBagZero from '@/icons/money-bag-zero';
import OneStopBox from '@/icons/one-stop-box';
import OrderInMinutes from '@/icons/order-in-minutes';
import RainCloudUmbrella from '@/icons/rain-cloud-umbrella';
import SavingsPiggyBank from '@/icons/savings-piggy-bank';
import SwapCars from '@/icons/swap-cars';
import { colors } from '@/theme/colors';
import { ReactNode } from 'react';

export interface CopyNode {
  text: ReactNode | string;
  icon: ReactNode;
}

type CopyVariant = 'homepage' | 'inventory';

const getIconProps = (isInventory: boolean) => ({
  className: 'h-[48px] w-[48px]',
  ...(isInventory
    ? {
        fillPrimary: colors.blue40,
        fillSecondary: colors.aqua40,
      }
    : {}),
});

export const AFFORDABLE = {
  title: 'Affordable',
  gradient: `linear-gradient(170deg, ${colors.aqua50} -56.55%, ${colors.blue30} 67.19%)`,
  copy: (variant: CopyVariant) => {
    const isInventory = variant === 'inventory';
    return [
      {
        text: isInventory ? (
          <span>
            20% lower
            <br />
            car payment
          </span>
        ) : (
          '20% lower car payment'
        ),
        icon: <SavingsPiggyBank {...getIconProps(isInventory)} />,
      },
      {
        text: isInventory ? (
          <span>
            Insurance
            <br />
            included
          </span>
        ) : (
          'Insurance included'
        ),
        icon: <RainCloudUmbrella {...getIconProps(isInventory)} />,
      },
      {
        text: isInventory ? (
          <span>
            Zero down
            <br />
            payment
          </span>
        ) : (
          'Zero down payment'
        ),
        icon: <MoneyBagZero {...getIconProps(isInventory)} />,
      },
      {
        text: isInventory ? (
          <span>
            Maintenance &<br />
            roadside covered
          </span>
        ) : (
          'Maintenance & roadside covered'
        ),
        icon: <CarEngineRepairMoney {...getIconProps(isInventory)} />,
      },
    ];
  },
};

export const FLEXIBLE = {
  title: 'Flexible',
  gradient: `linear-gradient(170deg, #9825FC -53.32%, ${colors.blue30} 67.82%)`,
  copy: (variant: CopyVariant) => {
    const isInventory = variant === 'inventory';
    return [
      {
        text: isInventory ? (
          <span>
            Cancel anytime with
            <br />
            no penalties
          </span>
        ) : (
          'Cancel anytime with no penalties'
        ),
        icon: <EnterDoor {...getIconProps(isInventory)} />,
      },
      {
        text: isInventory ? (
          <span>
            Swap cars with
            <br />
            the seasons or lifestages
          </span>
        ) : (
          'Swap cars with the seasons or lifestages'
        ),
        icon: <SwapCars {...getIconProps(isInventory)} />,
      },
    ];
  },
};

export const HASSLE_FREE = {
  title: 'Hassle-free',
  gradient: `linear-gradient(170deg, #FF00FB -81.23%, ${colors.blue30} 68.66%)`,
  copy: (variant: CopyVariant) => {
    const isInventory = variant === 'inventory';
    return [
      {
        text: isInventory ? (
          <span>
            One-stop solution for
            <br />
            all your car needs
          </span>
        ) : (
          'One-stop solution for all your car needs'
        ),
        icon: <OneStopBox {...getIconProps(isInventory)} />,
      },
      {
        text: isInventory ? (
          <span>
            Order in minutes with
            <br />
            no haggling
          </span>
        ) : (
          'Order in minutes with no haggling'
        ),
        icon: <OrderInMinutes {...getIconProps(isInventory)} />,
      },
    ];
  },
};
